var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import PaginatedTable from '@web/components/layout/PaginatedTable/PaginatedTable';
import { widgetMetricTableColgroupInvocationsByApp, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { PAGINATION_PAGE_SIZE, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, getLimitOffset, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToAppsUsageForDateRange } from '@web/utility/chartNavigation';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
export var PowerAiUsers = function () {
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _a = useFilters(), orgUnitId = _a.orgUnit, dateFrom = _a.dateFrom, dateTo = _a.dateTo, user = _a.user, page = _a.page;
    var _b = getLimitOffset(page, PAGINATION_PAGE_SIZE), limit = _b.limit, offset = _b.offset;
    var _c = trpc.invocationsByUser.useQuery({
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        limit: limit,
        offset: offset
    }, { enabled: !user }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (user) {
        return null;
    }
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamDiff = !!orgUnitId;
    var showOrgUnitName = !orgUnitId;
    var metricHeaderColspan = showTeamDiff ? 3 : 2;
    var columns = [
        {
            title: t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.label'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.invocations'),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: widgetMetricTablePairHeaderThClass
        },
        {
            title: t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.timeSpent'),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: widgetMetricTablePairHeaderThClass
        }
    ];
    var tableData = data.items.map(function (item) {
        var rk = String(item.userId);
        var navigateToUserGeminiAppsUsage = function () {
            navigateToAppsUsageForDateRange({
                navigateTo: navigateTo,
                dateFrom: dateFrom,
                dateTo: dateTo,
                userId: item.userId,
                orgUnitId: orgUnitId,
                tab: 'gemini'
            });
        };
        var invocationsCells = [
            {
                id: "".concat(rk, "-invocations-value"),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToUserGeminiAppsUsage }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.invocations.count })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(rk, "-invocations-period"), item.invocations.prevPeriodDiff, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            invocationsCells.push(metricTableTeamAvgDiffRowCell("".concat(rk, "-invocations-team"), item.invocations.teamAvgDiff, false));
        }
        var timeSpentCells = [
            {
                id: "".concat(rk, "-timeSpent-value"),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToUserGeminiAppsUsage }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.timeSpent.formatted })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(rk, "-timeSpent-period"), item.timeSpent.prevPeriodDiff, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            timeSpentCells.push(metricTableTeamAvgDiffRowCell("".concat(rk, "-timeSpent-team"), item.timeSpent.teamAvgDiff, false));
        }
        return __spreadArray(__spreadArray([
            {
                id: "".concat(rk, "-label"),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsxs("div", __assign({ className: "min-w-0 max-w-full cursor-pointer font-semibold break-words", onClick: navigateToUserGeminiAppsUsage }, { children: [item.userName, showOrgUnitName && item.orgUnitName ? (_jsxs("span", __assign({ className: "font-normal text-gray-500" }, { children: [' ', "(", item.orgUnitName, ")"] }))) : null] }))); }
            }
        ], invocationsCells, true), timeSpentCells, true);
    });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.powerAiUsers'), description: t('widgetTitleDescriptions.aiAdoptionAndUsage.powerAiUsers'), insightType: InsightTypeEnum.invocationsByUser, insightsData: data.items, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.powerAiUsers'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, data.items.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.label')] = showOrgUnitName && item.orgUnitName
                                            ? "".concat(item.userName, " (").concat(item.orgUnitName, ")")
                                            : item.userName,
                                        _a[t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.invocations')] = item.invocations.count,
                                        _a[t('app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.headers.timeSpent')] = item.timeSpent.formatted,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data.items) }) }), _jsx(PaginatedTable, { columns: columns, data: isInsightsDataEmpty(data.items) ? [] : tableData, total: data.total, pageSize: PAGINATION_PAGE_SIZE, typeResultText: '', columnColStyles: widgetMetricTableColgroupInvocationsByApp(showTeamDiff), tableClassName: "table-auto w-full", rowClassName: "border-b border-gray-200 last:border-0 [&>td]:align-top" })] })));
};
